import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ga from '../../util/googleAnalytics';

class EngagementTimer extends React.Component {
    constructor(props) {
        super(props);

        /* time expressed in seconds */

        this.state = {
            timeElapsed: 0
        }

        this.eventStartTime = 30
        this.eventInterval = 20
        this.eventStopTime = 150

        this.intervalHandle;
        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        this.beginNewTimer();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.beginNewTimer();
        } else {
            this.sendEngagementEvent();
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalHandle);
    }

    beginNewTimer() {
        this.setState({
            timeElapsed: 0
        });

        clearInterval(this.intervalHandle);

        this.intervalHandle = setInterval(this.tick, 1000);
    }

    tick() {
        const currTime = this.state.timeElapsed;

        this.setState({
            timeElapsed: currTime + 1
        });

        if (currTime >= this.eventStopTime) {
            clearInterval(this.intervalHandle);
        };
    }

    sendEngagementEvent() {
        const currTime = this.state.timeElapsed;

        if (this.isEventEligible(currTime)) {
            ga.sendEngagementEvent(this.props, currTime);
        };
    }

    isEventEligible(currTime) {
        let eligible = false;

        if (currTime == this.eventStartTime) {
            eligible = true;
        } else if (currTime > this.eventStartTime) {
            const timeWithinEventWindow = currTime - this.eventStartTime;

            eligible = (timeWithinEventWindow % this.eventInterval == 0);
        }

        return eligible;
    }

    render() {
        return <></>
    }
}

const mapStateToProps = (state) => {
    return {
        assessment: state.app.assessment
    }
};

export default withRouter(connect(mapStateToProps, null)(EngagementTimer));